import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "flex-fill" }
const _hoisted_3 = { class: "table valign-top" }
const _hoisted_4 = {
  key: 0,
  class: "text-success"
}
const _hoisted_5 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_6 = {
  key: 0,
  class: "text-success"
}
const _hoisted_7 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { key: 5 }
const _hoisted_14 = { key: 6 }

import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import CoreUiAvatar from "~/core-ui/vue/chat/CoreUiAvatar.vue";
import ElCardSectionWithTable from "~/cabinet/vue/interface/card/ElCardSectionWithTable.vue";
import {secondsFormat} from "~/core-ui/ts/CoreUiHelpersMixin";


import {defineComponent} from "vue";

const __default__ = defineComponent({
    name: "CoreUiDialogStatisticCard"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: {},
    avatar: {},
    statistic: {}
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _createVNode(ElCardHeader, null, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (__props.avatar)
              ? (_openBlock(), _createBlock(CoreUiAvatar, {
                  key: 0,
                  src: __props.avatar,
                  class: "mr-3",
                  size: "2em"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(ElCardSectionWithTable, null, {
        default: _withCtx(() => [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[0] || (_cache[0] = _createElementVNode("td", { style: {"width":"40%"} }, "Тип диалога", -1)),
                _createElementVNode("td", null, [
                  (__props.statistic.hasOnlineMessage)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (__props.statistic.isAnswered)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Онлайн диалог с ответом "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_5, " Пропущенный онлайн диалог "))
                      ], 64))
                    : (__props.statistic.hasOfflineMessage)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (__props.statistic.hasOfflineMessageAnswer)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Оффлайн диалог с ответом "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, " Оффлайн диалог без ответа "))
                        ], 64))
                      : (__props.statistic.isOperatorAnswerWithoutClientQuestion)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(" Оператор писал клиенту, а клиент не вступал с ним в диалог ")
                          ], 64))
                        : _createCommentVNode("", true)
                ])
              ]),
              (typeof __props.statistic.onlineAnswerTime == 'number')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                    _cache[1] || (_cache[1] = _createElementVNode("td", null, "Время первого ответа", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(secondsFormat)(__props.statistic.onlineAnswerTime)), 1)
                  ]))
                : _createCommentVNode("", true),
              (typeof __props.statistic.averageOnlineAnswerTime == 'number')
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _cache[2] || (_cache[2] = _createElementVNode("td", null, "Среднее время ответа", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(secondsFormat)(__props.statistic.averageOnlineAnswerTime)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, "Количество сообщений", -1)),
                _createElementVNode("td", null, [
                  _createTextVNode(" От клиента: " + _toDisplayString(__props.statistic.clientRealMessageCount) + " ", 1),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mr-2 ml-2" }, "/", -1)),
                  _createTextVNode(" От оператора: " + _toDisplayString(__props.statistic.operatorRealMessageCount), 1)
                ])
              ]),
              (__props.statistic.duration)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                    _cache[5] || (_cache[5] = _createElementVNode("td", null, "Продолжительность диалога", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(secondsFormat)(__props.statistic.duration)), 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.statistic.averageHoldTime)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                    _cache[6] || (_cache[6] = _createElementVNode("td", null, "Средняя задержка между двумя сообщениями оператора подряд", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(secondsFormat)(__props.statistic.averageHoldTime)), 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.statistic.firstMessageDeliveredToOperatorDelay)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                    _cache[7] || (_cache[7] = _createElementVNode("td", null, "Задержка между отправкой и доставкой первого сообщения клиента", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(secondsFormat)(__props.statistic.firstMessageDeliveredToOperatorDelay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.statistic.firstMessageReadedByOperatorDelay)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                    _cache[8] || (_cache[8] = _createElementVNode("td", null, "Задержка между отправкой и прочтением первого сообщения клиента", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(secondsFormat)(__props.statistic.firstMessageReadedByOperatorDelay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.statistic.delayBetweenFirstMessageReadAndAnswer)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                    _cache[9] || (_cache[9] = _createElementVNode("td", null, "Задержка между прочтением сообщения и отправкой ответа", -1)),
                    _createElementVNode("td", null, _toDisplayString(_unref(secondsFormat)(__props.statistic.delayBetweenFirstMessageReadAndAnswer)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})